import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Heatmap from "../../../../components/heatMap/heatMap";
import { actionCreators } from "../redux/checkInSaga";

function reOrderDays(series) {
  const clonedSeries = series.slice(0);

  return clonedSeries.map((item) => {
    if (item.data[0].toolTipData.includes("Sunday")) {
      item.data.push(item.data.shift());
    }

    return item;
  });
}

const HeatMapChart = () => {
  const dispatch = useDispatch();
  const showCheckInPrevPeriod = useSelector((state) => state.checkIn.showCheckInPrevPeriod);
  const series = useSelector((state) => reOrderDays(state.checkIn.series));
  const tableDataLoading = useSelector((state) => state.checkIn.tableDataLoading);
  const modalTableData = useSelector((state) => state.checkIn.modalTableData);
  const currentSelectedCategory = useSelector((state) => state.checkIn.currentSelectedCategory);

  const chartSettings = {
    heatMapRadius: 15,
    stroke: 0.5,
    toolTipWidth: 150,
    toolTipOffset: 120,
    series: reOrderDays(series),
    tableDataLoading,
    modalTableData,
    tableHeight: showCheckInPrevPeriod ? 300 : 320,
    displayAsBubbles: false,
    filledBubbles: true,
    selectedCategory: currentSelectedCategory,
    modalProps: {
      showPrevPeriod: showCheckInPrevPeriod,
      progressInPercent: false,
      mainMetricTitle: "Check-in",
      detailsTitle: "Successful Check-In Details"
    }
  };

  const handleDataClick = (tableDataUid) => {
    let data = {
      tableDataUid
    };
    dispatch(actionCreators.getTableData(data));
  };

  return <Heatmap {...chartSettings} handleDataClick={handleDataClick} />;
};

export default HeatMapChart;
